import apiUrl from '../../../../constants'
import axios from "axios";
import CryptoJS from "crypto-js";
import Paginate from "vuejs-paginate";
import { Validator } from "vee-validate";
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../../common/PageTrackerHelper'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import keycloak from '../../../../common/Keycloak';

export default {
  name: "Edit Debit",
  components: {
    VueElementLoading,
    Paginate,
    Multiselect,
  },
  mixins: [PageTracker],
  props: [],
  data() {
    return {
      isPageLoaded: false,
      search: '',
      max: 500,
      comments: '',
      shipmentlogmodal: false,
      pageno: 0,
      pagecount: 0,
      fromDate: new Date().toISOString().split("T")[0],
      toDate: new Date().toISOString().split("T")[0],
      processmode: "",
      status: "",
      returnArray: [],
      agentDetailss: [],
      agentShipmentDetails: [],
      resultCount: '',
      adjustDebitAmount: 0,
      isDebitPersonSelected: "",
      DocketNumber: "",
      ChallanNumber: "",
      deliveyolduserid: "",
      LostShipInfo: {
        shippingid: '',
        origin: '',
        destination: '',
        currentHub: '',
        currentHubID: '',
        netAmt: 0,
        NetShipmentValue: 0,
        ShipmentStatus: '',
        ActionStatus: '',
        DebitAmt: 0,
        status: '',
        DebitFrom: '',
        DebitMode: '',
        DebitConserPerson: '',
        Courier: "",
        Coloader: "",
        Vendor: "",
        RSC: "",
        BranchDebit:"",
        DebitAmount: 0
      },

      ClientName: '',
      ClientID: '',
      CurrentHubZoneID: '',
      CurrentHubZoneName: '',
      ServiceCenter: false,
      supeAgentCourier: false,
      Coloader: false,
      LocalVendor: false,
      debitModeflag: false,
      attchmentFlag: false,
      DocketNumebr: false,
      userCategory: [],
      DebitFromObj: [{ "id": "ServiceCenter", "Debit_name": "ServiceCenter" },
      { "id": "Courier", "Debit_name": "SuperAgent" },
      { "id": "Coloader", "Debit_name": "Coloader" },
      { "id": "Vendor", "Debit_name": "LocalVendor" },
      { "id": "NetworkVendor", "Debit_name": "NetworkVendor" },
      {"id": "RSC", "Debit_name": "RSCOwner"},
      {"id": "BranchDebit", "Debit_name": "BranchDebit"}
    ],
      DebitModeObj: [],
      CourierObj: [],
      VendorObj: [],
      users: [],
      shipmentLog: [],
      selected: [],
      allSelected: false,
      userIds: [],
      selectedItems: [],
      selectedRSCHubs: [],
      selectAllItems: false,
      ColoaderObj: [],
      empDetails: [],
      UpdateCurrentHubId: '',
      parentHubObj: [],
      danger: '',
      attachmentPath: '',
      isAPICallFlag: true,
      debitPersonAmount: [],
      debitPersonPercent: [],
      oldcourieroutsourcingId: [],
      file: '',
      Loading: false,
      getUploadError: [],
      uploadError: '',
      validated: true,
      DefaultDebitCategory: [],
      DebitCatLoader: false,
      DebitUserSelectedOptions: [],
      loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      debitCatLoader: "",
      debitCatSelected: [],
      isDebitPersonLoading: false,
      isSaveLoading: false,
      dataLoading: false,
      filteredEmpTotalCount: 0,
      selectedfilteredEmpCount: 0,
      keyUserId: 'userid',
      keyName: 'username',
      amountExceedError: false,
      selectAlluser: false,
      shippingIdForMeta: "",
      NetPaymentArr: [],
      TableDetails: [],
      apiResponseforTable: [],
      modelValue: false,
      TotalSum: 0,
      styleObjectFailure: {
        'text-color': 'red',
        'color':'red'
      },
      styleObjectSuccess: {
        'text-color': 'green',
        'color':'green'
      },
      GstValue: 0,
      selectAllItems: false,
      rscShipments: false,
      rscOwnerList: [],
      globalShippingid : null,
      utype: [2,3],
      userDataKey : '',
      hubList:[],
      RSCObj:[],
      BranchDebit:'',
      IsRSC:false,
      IsRSCVal:'',
      userInfo:{},
      // rscShipments: false,
      // rscOwnerList: [],
      losthubconfig: '',
      isLostNewFeaturesisOnThisHub: false,
      unfilterdEmpDetails : [],
      LoggedInUserJobProfile: '',
      sortByVerticalAsc: true,
      sortByTypeAsc: true,
      sortByVerticalAsc: true,
      sortPriority: ['Vertical', 'Type'],
      currentDebitDetails: {
        potentialLostNoDebit: false
      },
      mergedOldEmployeeDetails: [],
      userRoleList: []
    }
  },
  computed: {
    // filteredEmployees: function () {
    //   var self = this;
    //   this.filteredEmpTotalCount = this.empDetails.length
    //   return this.empDetails.filter(function (emp) { return emp.username.toLowerCase().indexOf(self.search.toLowerCase()) >= 0; });
    //   //return this.customers;
    // },
    filteredEmployees() {
      const searchLower = this.search.toLowerCase();
      const selected = this.selectedItems || [];

      let filtered = this.empDetails.filter(emp => {
        return (
          emp.username.toLowerCase().includes(searchLower) ||
          String(emp.EmployeeID).toLowerCase().includes(searchLower)
        );
      });

      // Apply sorting based on priority
      return filtered.sort((a, b) => {

        //selected user pick and et to the top of table.
        // ✅ selected rows on top (composite key)
        const aKey = `${a.username}${a.userid}`;
        const bKey = `${b.username}${b.userid}`;

        const aSelected = selected.includes(aKey);
        const bSelected = selected.includes(bKey);

        if (aSelected !== bSelected) {
          return bSelected - aSelected;
        }

        for (let key of this.sortPriority.slice().reverse()) {
          let valA = (a[key === 'Type' ? 'EmpTypeName' : 'Vertical'] || '').toLowerCase();
          let valB = (b[key === 'Type' ? 'EmpTypeName' : 'Vertical'] || '').toLowerCase();

          let asc = key === 'Type' ? this.sortByTypeAsc : this.sortByVerticalAsc;

          if (valA < valB) return asc ? -1 : 1;
          if (valA > valB) return asc ? 1 : -1;
          // if equal, go to next sort key
        }
        return 0;
      });
    }
  },
  created: async function () {
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    if (this.$route.query.shippingid) {
      this.getLostShipmentDetails(this.$route.query.shippingid);
    } else if(this.$route.query.id){
      await this.getLostShipmentDetails(this.$route.query.id);
    } else{
      this.$router.push('/MarkLostShipment');
    }
    this.pageno = 0;
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    console.log('userdetail', userdetail);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.rolename = userdetail.userrole[0]['rolename'];
    this.hubdetails = userdetail.hubdetails[0];
    this.userInfo = userdetail;
    this.LoggedInUserJobProfile = userdetail.jobProfile
    this.userRoleList = userdetail.userrole.map((role) => role.rolename.toLowerCase());

    var IsRSCEncrypt = window.localStorage.getItem('IsRSC')
    var bytes = CryptoJS.AES.decrypt(IsRSCEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    this.IsRSCVal = JSON.parse(plaintext);
    this.GetGst();

    var IshubconfigsEncrypt = window.localStorage.getItem('hubconfigs')
    var bytes = CryptoJS.AES.decrypt(IshubconfigsEncrypt.toString(), this.userDataKey);
    this.losthubconfig = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    console.log("this.losthubconfig ====================================>>>",this.losthubconfig);
    let isLostNewFeatures = await this.getDataFromRedisbyKeyNameCommonFun({
      "key": "newLostDebitUserRestrictionHubLevelConfig"
    })
    console.log('isLostNewFeatures --------->>', isLostNewFeatures);
    this.isLostNewFeaturesisOnThisHub = isLostNewFeatures.includes(0) || isLostNewFeatures.includes(this.hubdetails) ? true : false;
    console.log('this.isLostNewFeaturesisOnThisHub -asd------->>', this.isLostNewFeaturesisOnThisHub);

    this.getDebitFromDetailsFromRedis = await this.getDataFromRedisbyKeyName({
      "key": "lostdebitfromtypesconfig"
    })
    // let defineConfig = {
    //   loggedInHubdetails: this.losthubconfig,
    //   debitfromtypeconfigs: this.getDebitFromDetailsFromRedis ? this.getDebitFromDetailsFromRedis: false,
    //   loggedinuserRole: this.LoggedInUserJobProfile,
    //   isRsc: this.IsRSCVal, //need to check how define RSC
    //   hubid: this.LostShipInfo.currentHubID,
    //   userDept: this.userInfo.department ? this.userInfo.department : false
    // }
    //REASSIGN TO CURRENT
    // this.hubdetails = this.LostShipInfo.currentHubID
    // await this.setDebitFromTypeOptionsBasedonConfig(defineConfig)
    console.log('this.getDebitFromDetailsFromRedis ------->>', this.getDebitFromDetailsFromRedis);
    let parseShipment = this.$route.query.id ? JSON.parse(this.$route.query.id) : ""
    this.getShipmentDebitDetails(parseShipment)

  },
  watch: {
    adjustDebitAmount(val) {
      let checkReminder = val.split(".")
      if (checkReminder[0] != 0) {
        this.amountExceedError = true
      } else {
        this.amountExceedError = false
      }
    }
  },
  methods: {
    onDebitFromChange() {
      if (!this.isPageLoaded) return; // ignore first trigger
        this.BindDebitFrom();
    },
    getDataFromRedisbyKeyName(keypayload){
      return new Promise((resolve, reject) => {
        try {
          axios.post(apiUrl.api_url + 'rediscluster/get', keypayload)
            .then((response) => {
              if (response.data.code === 200) {
                resolve(JSON.parse(response.data.message))
              }
              if (response.data.message == false) {
                resolve(false);
              }
            })
        } catch (e) {
          console.log("Unable to read data from redis.!", e);
        }
      })
    },
    async setDebitFromTypeOptionsBasedonConfig(reqparams){
      try {
        let { loggedInHubdetails, debitfromtypeconfigs,  loggedinuserRole, isRsc, hubid, userDept } = reqparams;

        if( userDept && (userDept.toLowerCase() == 'line haul' || userDept.toLowerCase() == 'linehaul')) {
          // console.log('this is line haul department.!', this.DebitFromObj);
          this.DebitFromObj = this.DebitFromObj.filter((opt) => opt.Debit_name.toLowerCase() == 'networkvendor' ||  opt.Debit_name.toLowerCase() == 'localvendor' || opt.Debit_name.toLowerCase() == 'coloader');
          return true;
        }

        if (debitfromtypeconfigs && debitfromtypeconfigs.length ) {
          let getfilteredData = debitfromtypeconfigs.filter((obj) => obj.centertype == loggedInHubdetails.CenterType && obj.soc == loggedInHubdetails.SOC);
          console.log('getfilteredData ------------>>', getfilteredData);
          if (getfilteredData.length){
            let debitoptions = getfilteredData[0].options.split(",").map(option => option.trim().toLowerCase());
            this.DebitFromObj = this.DebitFromObj.filter((debitoption) => {
              if(debitoptions.includes(debitoption.Debit_name.toLowerCase().trim())) {
                return debitoption;
              }
            })
          }
        }

        //hub basis filter.
        if ( isRsc !=0 ) {
          this.IsRSC=true;
          this.DebitFromObj = this.DebitFromObj.filter((opt) => opt.Debit_name.toLowerCase() != 'servicecenter' &&  opt.Debit_name.toLowerCase() != 'superagent');
          this.LostShipInfo.DebitFrom="RSC"
          this.BindDebitFrom()
        } else {
          this.DebitFromObj = this.DebitFromObj.filter((opt) => opt.Debit_name.toLowerCase() != 'rscowner');
        }
        console.log('Final Debit from types  ---------->>', this.DebitFromObj);
        let outsourcingdetails = await this.getOutSourcingDetailsfromdb(hubid);
        console.log("Page outsourcingdetails ===========>>", outsourcingdetails);
        console.log("this.DebitFromObj ===========>>", this.DebitFromObj);
        if( outsourcingdetails.data.length == 0) {
          this.DebitFromObj = this.DebitFromObj.filter((opt) => opt.Debit_name.toLowerCase() != 'superagent');
          console.log("this.DebitFromObj =========>>", this.DebitFromObj);
        }
      } catch(e) {
        console.log("Catch Exception..!!", e);
        return true;
      }
    },
    getOutSourcingDetailsfromdb(hubid) {
      return new Promise((resolve, reject) => {
        try {
          axios.post(apiUrl.api_url + 'external/OutSourcingAgentLIst', { "HubID": hubid, "EntityType": "Agent" })
          .then((response) => {
            if (response.data.code === 200) {
              resolve({data: response.data.data, message:"success", "code": 200})
            } else {
              resolve({data: [], message:response.data.message, "code": 204})
            }
          })
          .catch((httpException) => {
            this.$alertify.error("Courier data not found");
            console.error('exception is:::::::::', httpException)
          })
        } catch(e) {
          console.log('Unable to get Outsourcing details.!!', e);
        }
      })
    },
    GetGst() {
      let reqpayload = {
        "key": "isGstValue"
      }
      axios.post(apiUrl.api_url + 'rediscluster/get', reqpayload)
        .then((response) => {
          if (response.data.code === 200) {
            let gstVal = JSON.parse(response.data.message)
            this.GstValue = gstVal.gst
          }
          if (response.data.message == false) {
            this.$alertify.error("GST Value Not found");
          }
        })
    },
    setcheckboxGst($event, item, index) {
      if ($event.target.checked == true) {
        this.SetPenaltyAmt(true, item, index);
      } else {
        this.SetPenaltyAmt(false, item, index)
      }
    },
    SetPenaltyAmt(item, index) {
      this.TableDetails[index].Penalty  = this.TableDetails[index].Penalty ? parseFloat(this.TableDetails[index].Penalty).toFixed(2) : 0
      let TotalAmount = 0
      if (item.Gst == false) {
        TotalAmount = parseFloat(this.TableDetails[index].GreaterDebitAMt) + parseFloat(this.TableDetails[index].GreaterDebitAMt * (this.GstValue / 100))
      } else {
        TotalAmount = this.TableDetails[index].GreaterDebitAMt
      }
      this.TableDetails[index].TotalDebitAmt = (parseFloat(TotalAmount) + parseFloat(this.TableDetails[index].Penalty ? this.TableDetails[index].Penalty : 0)).toFixed(2)
      $(`#index_${index}`).html((parseFloat(TotalAmount) + parseFloat(this.TableDetails[index].Penalty ? this.TableDetails[index].Penalty : 0)).toFixed(2))
      this.CalculateTotal();
    },
    CalculateTotal() {
      let Amount = 0;
      let len = this.TableDetails.length
      for (let i = 0; i < len; i++) {
        Amount += parseFloat(this.TableDetails[i].TotalDebitAmt)
      }
      this.TotalSum = parseFloat(Amount).toFixed(2)
      this.calculateDebitAmout(this.TotalSum, 100);
    },
    async getLostShipmentDetails(shippingIds) {
      try {
        this.dataLoading = true;

        const parsedShippingIds = shippingIds ? JSON.parse(shippingIds) : "";

        this.globalShippingid = parsedShippingIds;

        const reqObj = {
          ShippingID: parsedShippingIds
        };

        if (!reqObj.ShippingID) {
          this.$alertify.error("Shipment parameters not found");
          return false;
        }

        const response = await axios.post(
          apiUrl.api_url + 'shipmentLost/getShipmentDetails',
          reqObj
        );

        if (response.data.code !== 200) {
          this.TableDetails = [];
          this.LostShipInfo = [];
          this.$alertify.error("Lost Shipment data not found");
          return false;
        }

        // =========================
        // SUCCESS CASE
        // =========================
        this.TableDetails = response.data.data;

        this.getShipmentDetailsfromUpdateshipment();

        let resLen = this.TableDetails.length;
        this.TotalSum = 0;

        for (let i = 0; i < resLen; i++) {
          let item = this.TableDetails[i];

          item.OctroiMRP = item.OctroiMRP != null ? item.OctroiMRP : 0;
          item.NetPayment = item.NetPayment != null ? item.NetPayment : 0;

          if (parseFloat(item.OctroiMRP) > parseFloat(item.NetPayment)) {
            item.GreaterDebitAMt = parseFloat(item.OctroiMRP);
          } else {
            item.GreaterDebitAMt = parseFloat(item.NetPayment);
          }

          item.Gst = true;
          item.Penalty = 0;
          item.TotalDebitAmt = item.GreaterDebitAMt;

          this.TotalSum += parseFloat(item.GreaterDebitAMt);
        }

        // Remove duplicate RSC owners
        this.rscOwnerList = [...new Set(this.rscOwnerList)];

        const getResult = response.data.data;

        const getNetPayment = getResult[0].NetPayment != null ? getResult[0].NetPayment : 0;
        const getOctroiMRP = getResult[0].OctroiMRP != null ? getResult[0].OctroiMRP : 0;

        this.LostShipInfo = {
          shippingid: getResult[0].ShippingID,
          origin: getResult[0].OriginHubName,
          destination: getResult[0].FinalDestinationName,
          currentHub: getResult[0].CurrentHubName,
          netAmt: getNetPayment,
          NetShipmentValue: getOctroiMRP,
          ShipmentStatus: getResult[0].ShipmentStatus,
          ActionStatus: 'MarkLost',
          status: getResult[0].Status,
          currentHubID: getResult[0].CurrentHubId,
          currentHubZoneID: getResult[0].CurrentHubZoneID,
          DebitAmount: parseFloat(getNetPayment) > parseFloat(getOctroiMRP) ? getNetPayment : getOctroiMRP,
          DebitFrom: '',
          DebitMode: '',
          Courier: '',
          RSC: '',
          BranchDebit: getResult[0].OriginHubName,
          Coloader: '',
          Vendor: ''
        };

        this.ClientName = getResult[0].ClientName;
        this.ClientID = getResult[0].ClientID;
        this.CurrentHubZoneID = getResult[0].CurrentHubZoneID;
        this.CurrentHubZoneName = getResult[0].CurrentHubZoneName;

      } catch (error) {
        this.$alertify.error("Lost Shipment data not found");
        console.error("exception is:::::::::", error);
      } finally {
        this.dataLoading = false;
      }
    },
    async getShipmentDebitDetails(shipments = []) {
      if( shipments.length == 0 ) {
        this.$alertify.error("Empty shipments Debit Details.!");
        return false;
      }
      const reqObj = {
        shipmentIds: shipments
      }
      try {
        const debitresult = await axios.post(apiUrl.api_url + 'shipmentLost/getDebitDetails/shippingid', reqObj);
        let isPotential = (!this.TableDetails[0].ispotentiallost || this.TableDetails[0].ispotentiallost == false || this.TableDetails[0].ispotentiallost == 'null' )
        if( debitresult.data.code != 200 && isPotential ) {
          this.$alertify.error("Debit Details not found.!");
          this.$router.push('/RMApprove');
          return false;
        }
        if(this.TableDetails[0].ispotentiallost && debitresult.data.code != 200) {
          this.currentDebitDetails.potentialLostNoDebit = true;
          return true;
        }

        const { ShipmentLostMasterID, DebitFromType, Penalty, Gst, CurrentHubID, shipmentlostdebitdetails, DebitPersonalDetails } = debitresult.data.data[0];
        // console.log("DebitFromType ====>>", DebitFromType);
        // console.log("shipmentlostdebitdetails ====>>", shipmentlostdebitdetails);

        /**
         Current Debit Req object.
        */
        this.currentDebitDetails.DebitFromType = DebitFromType
        this.currentDebitDetails.CurrentPenalty = Penalty
        this.currentDebitDetails.shipmentlostdebitdetails = shipmentlostdebitdetails
        this.currentDebitDetails.DebitPersonalDetails = DebitPersonalDetails
        console.log("this.currentDebitDetails ===================>>>>>>>", this.currentDebitDetails);
        /**
          As per shipment's current hub show debitfromtypes.
        */
        let defineConfig = {
          loggedInHubdetails: this.losthubconfig,
          debitfromtypeconfigs: this.getDebitFromDetailsFromRedis ? this.getDebitFromDetailsFromRedis: false,
          loggedinuserRole: this.LoggedInUserJobProfile,
          isRsc: DebitFromType == 'RSC' ? '1' : '0', //need to check how define RSC
          hubid: CurrentHubID,
          userDept: this.userInfo.department ? this.userInfo.department : false
        }
        //REASSIGN TO CURRENT
        this.hubdetails = CurrentHubID
        this.LostShipInfo.DebitFrom = DebitFromType;
        await this.setDebitFromTypeOptionsBasedonConfig(defineConfig)



        // update penalty and gst details..
        this.TableDetails[0].Penalty = Penalty;
        this.TableDetails[0].Gst = Gst > 0 ? false : true;
        this.SetPenaltyAmt({}, 0)


        if(DebitFromType == 'ServiceCenter' || DebitFromType == 'Store') {
          console.log("ServiceCenter Logging....");

          this.LostShipInfo.DebitFrom = 'ServiceCenter';
          await this.BindDebitFrom(shipmentlostdebitdetails, DebitPersonalDetails);

          this.mergedOldEmployeeDetails = await this.setSRDetailsSelections(shipmentlostdebitdetails, DebitPersonalDetails, DebitFromType)
          this.currentDebitDetails.mergeDebitPersonsToCompareEdits = this.mergedOldEmployeeDetails
          console.log("MERGED VENKY EMPL DETAILS ====>>", this.mergedOldEmployeeDetails);
        } else if(DebitFromType == 'Courier' ) {

          await this.BindDebitFrom(shipmentlostdebitdetails, DebitPersonalDetails);
          this.LostShipInfo.Courier = shipmentlostdebitdetails.length ? shipmentlostdebitdetails[0].CourierID : '0'
        } else if ( DebitFromType == 'BranchDebit' ) {

          await this.BindDebitFrom(shipmentlostdebitdetails, DebitPersonalDetails);
          this.LostShipInfo.BranchDebit = shipmentlostdebitdetails.length ? shipmentlostdebitdetails[0].DebitID : '0'
        } else if( DebitFromType == 'Coloader' ) {

          await this.BindDebitFrom(shipmentlostdebitdetails, DebitPersonalDetails);
          this.LostShipInfo.Coloader = shipmentlostdebitdetails.length ? shipmentlostdebitdetails[0].ColoaderID : '0'
        } else if( DebitFromType == 'NetworkVendor' || DebitFromType == 'Vendor' ) {

          await this.BindDebitFrom(shipmentlostdebitdetails, DebitPersonalDetails);
          this.LostShipInfo.Vendor = shipmentlostdebitdetails.length ? shipmentlostdebitdetails[0].VehicleVendorID : '0'
        } else if( DebitFromType == 'RSC' ) {

          await this.BindDebitFrom(shipmentlostdebitdetails, DebitPersonalDetails);
          this.setSRDetailsSelections(shipmentlostdebitdetails, DebitPersonalDetails, DebitFromType)
          this.LostShipInfo.RSC = shipmentlostdebitdetails.length ? shipmentlostdebitdetails[0].DebitID : '0'
        } else {
          console.log("No DebitFromType found.!");
        }

        //map Values.
        // console.log("TESTINGGGGGGGGGGGG ==============================>>>", this.LostShipInfo.DebitFrom);
        //
        // console.log("Values Has been set.", shipmentlostdebitdetails);
        // console.log("debitdetails ===========>>>", shipmentlostdebitdetails[0].CourierID);



      } catch ( error ){
        console.error('API Error:', error);
      }
    },
    async setSRDetailsSelections(shipmentlostdebitdetails, DebitPersonalDetails, debitType) {
      let mergedDebits= [];
      if(debitType == 'RSC') {

        mergedDebits = shipmentlostdebitdetails.map(function(item) {
          const match = DebitPersonalDetails.find(function(d) {
            return d.ShipmentLostDetailsID === item.ShipmentLostDetailsID;
          });

          return Object.assign({}, item, match || {});
        });

      } else {
        // Step 1: Group personal details by SRAgencyID
        const personalMap = {};

        // group personal details by SRAgencyID
        if(DebitPersonalDetails && DebitPersonalDetails.length) {
          DebitPersonalDetails.forEach(function(d) {
            if (!personalMap[d.SRAgencyID]) {
              personalMap[d.SRAgencyID] = [];
            }
            personalMap[d.SRAgencyID].push(d);
          });
        }

        shipmentlostdebitdetails.forEach(function(item) {
          const matches = personalMap[item.SRAgencyID];

          if (matches && matches.length) {
            matches.forEach(function(m) {
              // console.log("MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM=================>>",m);
              mergedDebits.push(
                Object.assign({}, m, {
                    DebitFromType: item.DebitFromType   // 👈 new key
                  })
              );

            });
          } else {
            // no personal details → keep shipment record
            mergedDebits.push(item);
          }
        });
      }
      console.log("mergedDebits ===================================================>>", mergedDebits);
      if(mergedDebits.length > 0) {
        for (let val of mergedDebits) {

          let matchedObj = this.filteredEmployees.find(function(obj) {
            const compareId = ['Store', 'RSC'].includes(val.DebitFromType) ? val.UserID : val.DeliveryUserID;
            return String(obj.userid) === String(compareId);
          });

          if(matchedObj) {
            this.selectedItems.push(`${matchedObj.username}${matchedObj.userid}`);
            this.debitPersonAmount[`${matchedObj.username}${matchedObj.userid}`] = val.DebitAmount;
            this.debitPersonPercent[`${matchedObj.username}${matchedObj.userid}`] = val.DebitPercentage;
          }
        }

        this.isDebitPersonSelected = this.selectedItems.length;
        return mergedDebits;
      }
    },
    getShipmentDetailsfromUpdateshipment() {
      if (this.TableDetails[0].ShippingID != undefined && this.TableDetails[0].ShippingID != []) {
        let reqObj = { shippingID: this.TableDetails[0].ShippingID ? this.TableDetails[0].ShippingID.toString() : ""}
        axios.post(apiUrl.api_url + 'shipmentMisrout/getShipmemtsdetails',reqObj)
          .then((response) => {
            if (response.data.code === 200) {
              let UpdateshipmentDetails = response.data.data;
              this.UpdateCurrentHubId = UpdateshipmentDetails.CurrentHubID;
              try {
                let TrackerInfo = {
                  projectname: "Last Mile",
                  type: "Web",
                  userid: this.localuserid,
                  username: this.localusermailid,
                  routeurl: "shipmentMisrout/getShipmemtsdetails",
                  meta: {
                    event: "shipmentMisrout-getShipmemtsdetails",
                    shipmentId: reqObj ? (reqObj.shippingID ? reqObj.shippingID : null) : null,
                    hubId: this.hubdetails ? this.hubdetails : null,
                    remarks: "Frontend",
                  },
                };
                this.PageTracker(TrackerInfo);
              } catch (error) {
                console.log(error);
              }
            }
            else {
              this.UpdateCurrentHubId = this.TableDetails[0].CurrentHubId
            }
          })
          .catch((httpException) => {
            this.UpdateCurrentHubId = this.LostShipInfo.currentHubID
            console.error('exception is:::::::::', httpException)
          })
      }
    },
    ShowShipmentLog(userid) {
      this.$validator.reset();
      this.errors.clear();
      axios.get(apiUrl.api_url + `external/getshipmentlog?ShippingID=${userid}`)
        .then((response) => {
          this.shipmentlogmodal = true;
            if(response.data.code===200){
            this.shipmentLog = response.data.data;
          }
          else {
            this.shipmentLog = [];
          }
        })
        .catch((httpException) => {
          this.$alertify.success("Shpment Log data not found");
          console.error('exception is:::::::::', httpException)
        })

    },
    closeShipmentLogModal() {
      this.shipmentlogmodal = false;
      this.$validator.reset();
      this.errors.clear();
    },
    selectAll(ev) {
      this.userIds = [];
      if (ev.target.checked == true) {
        this.DebitUserSelectedOptions = []
        for (let user in this.users) {
          this.DebitUserSelectedOptions.push(this.users[user]);
        }
      } else {
        this.DebitUserSelectedOptions = []
      }
      this.changeloadEmployess();
    },
    // customBConfigLabel ({ BusinessConfig }) {
    //   console.log('users',BusinessConfig);
    //   return `${BusinessConfig}`
    // },
    customBConfigLabel({ EmpTypeName, EmpCategoryId, EmpTypeId }) {
      return `${EmpTypeName}`
    },
    userObj(obj) {
      // console.log('object',obj);
      //this.userIds.push(obj.EmpTypeId);
    },
    resetDropdown() {
      this.DebitUserSelectedOptions = []
    },
    changeloadEmployess() {
      this.debitCatSelected = [];
      if (this.DebitUserSelectedOptions.length > 0) {
        for (let debitCatID in this.DebitUserSelectedOptions) {
          this.debitCatSelected.push(this.DebitUserSelectedOptions[debitCatID].EmpTypeId)
          //console.log('this.userIds ---->>>',this.debitCatSelected);
        }
        this.selectAlluser = this.DebitUserSelectedOptions.length == this.users.length ? true : false;
        this.LoadEmployees();

      } else {
        this.debitCatSelected = [];
        this.LoadEmployees(true);
      }
    },
    selectItems(getevent) {
      this.selectedItems = []
      if (getevent.target.checked == true) {
        for (let emp in this.empDetails) {
          let val = `${this.empDetails[emp][this.keyName]}${this.empDetails[emp][this.keyUserId]}`;
          this.selectedItems.push(val);
          // this.selectedItems.push(this.empDetails[emp].username.toString());
        }
      } else {
        for (let emp in this.empDetails) {
          this.debitPersonAmount[`${this.empDetails[emp][this.keyName]}${this.empDetails[emp][this.keyUserId]}`] = '';
          this.debitPersonPercent[`${this.empDetails[emp][this.keyName]}${this.empDetails[emp][this.keyUserId]}`] = '';
        }
        this.selectedItems = [];
        this.adjustDebitAmount = 0;
      }
      this.selectedfilteredEmpCount = this.selectedItems.length
      this.calculateDebitAmout(this.TotalSum, 100);
    },
    async BindDebitFrom(debitdetails = [], srDetails = []) {
      try {
        console.log("BindDebitFrom called:", debitdetails);
        console.log("BindDebitFrom VENKY this.LostShipInfo.DebitFrom:", this.LostShipInfo.DebitFrom);

        this.clear();
        const Debitfrom = this.LostShipInfo.DebitFrom;

        // console.log("getShipmentDebitDetails===>", Debitfrom);

        // if( this.currentDebitDetails && this.currentDebitDetails.DebitFromType != DebitFrom ) {
        //   console.log("getShipmentDebitDetails===>", this.currentDebitDetails);
        //   let parseShipment = this.$route.query.id ? JSON.parse(this.$route.query.id) : ""
        //   this.getShipmentDebitDetails(parseShipment)
        // }



        // ================= SERVICE CENTER =================
        if (Debitfrom === 'ServiceCenter') {

          this.DebitModeObj = [
            { id: "Cash In Hand", Debit_mode: "Cash In Hand" },
            { id: "Salary", Debit_mode: "Salary" }
          ];

          // Parent Hub API
          if (this.hubdetails) {
            try {
              const response = await axios.post(
                apiUrl.api_url + 'external/getParentHubs',
                { HubID: this.hubdetails }
              );

              if (response.data.code === 200) {
                this.parentHubObj = response.data.data;
              } else {
                this.parentHubObj = [];
                this.$alertify.error(response.data.message);
              }

            } catch (err) {
              this.$alertify.error("parent hub data not found");
              console.error("ParentHub API error:", err);
            }
          }

          // Employee List
          if (this.isLostNewFeaturesisOnThisHub) {
            await this.LoadEmployees();
          } else {
            try {
              this.debitCatLoader = this.loader;

              let apiendpoint = 'external/GetEmployeeTypeMasterList';
              if (keycloak.enableKavach) {
                apiendpoint = 'user/migration/getemployeetypemasterlist';
              }

              const response = await axios.post(
                apiUrl.api_url + apiendpoint,
                { appkey: "$LAST$Mile%#$" }
              );

              if (response.data.code === 200) {
                this.users = response.data.FilterdData.rows;
              } else {
                this.users = [];
                this.$alertify.error(response.data.message);
              }

              this.debitCatLoader = "";

            } catch (err) {
              this.$alertify.error("UserCategory data not found");
              console.error("Employee API error:", err);
            }
          }
        }

        // ================= COURIER =================
        else if (Debitfrom === 'Courier') {

          this.DebitModeObj = [
            { id: "Cash", Debit_mode: "Cash" },
            { id: "Cheque", Debit_mode: "Cheque" },
            { id: "Invoice", Debit_mode: "Invoice" },
            { id: "COF", Debit_mode: "COF" }
          ];
          console.log("this.hubdetails ==============>>>", this.hubdetails);
          if (this.hubdetails) {
            try {
              const response = await axios.post(
                apiUrl.api_url + 'external/OutSourcingAgentLIst',
                { HubID: this.hubdetails, EntityType: "Agent" }
              );

              if (response.data.code === 200) {
                this.CourierObj = response.data.data;

                this.CourierObj.forEach(c => {
                  this.oldcourieroutsourcingId[c.id] = c.OldOutSourcingMasterId;
                });
                console.log("this.CourierObj -============>>>", this.CourierObj);
              } else {
                this.CourierObj = [];
                this.LostShipInfo.Courier = '';
                this.$alertify.error(response.data.message);
              }

            } catch (err) {
              this.$alertify.error("Courier data not found");
              console.error("Courier API error:", err);
            }
          }

          await this.$nextTick();

        }

        // ================= COLOADER =================
        else if (Debitfrom === 'Coloader') {

          try {
            const reqObj = { ShippingID: this.globalShippingid, OptType: 'Coloader' };

            const response = await axios.post(
              apiUrl.api_url + 'external/getOptTypeDetails',
              reqObj
            );

            if (response.data.code === 200) {
              this.ColoaderObj = response.data.data;
            } else {
              this.ColoaderObj = [];
              this.LostShipInfo.Coloader = '';
              this.$alertify.error(response.data.message || 'Coloader data not found.!');
            }

          } catch (err) {
            this.$alertify.error("Coloader data not found");
            console.error("Coloader API error:", err);
          }
        }

        // ================= VENDOR =================
        else if (Debitfrom === 'Vendor') {

          try {
            const reqObj = { ShippingID: this.globalShippingid, OptType: 'Vehicle Vendor' };

            const response = await axios.post(
              apiUrl.api_url + 'external/getOptTypeDetails',
              reqObj
            );

            if (response.data.code === 200) {
              this.VendorObj = response.data.data;
            } else {
              this.VendorObj = [];
              this.LostShipInfo.Vendor = '';
              this.$alertify.error(response.data.message || 'Vendor data not found.!');
            }

          } catch (err) {
            this.$alertify.error("Vendor data not found");
            console.error("Vendor API error:", err);
          }
        }

        // ================= NETWORK VENDOR =================
        else if (Debitfrom === 'NetworkVendor') {

          try {
            const reqObj = { ShippingID: this.globalShippingid, OptType: 'Network Vendor' };

            const response = await axios.post(
              apiUrl.api_url + 'external/getOptTypeDetails',
              reqObj
            );

            if (response.data.code === 200) {
              this.VendorObj = response.data.data;
            } else {
              this.VendorObj = [];
              this.LostShipInfo.Vendor = '';
              this.$alertify.error(response.data.message || 'Network Vendor data not found.!');
            }

          } catch (err) {
            this.$alertify.error("NetworkVendor data not found");
            console.error("NetworkVendor API error:", err);
          }
        }

        // ================= RSC =================
        else if (Debitfrom === "RSC") {

          this.DebitModeObj = [
            { id: "Cash In Hand", Debit_mode: "Cash In Hand" },
            { id: "Salary", Debit_mode: "Salary" }
          ];

          if (this.hubdetails) {
            try {
              const reqObj = { HubIds: [this.hubdetails], ShippingID: this.globalShippingid };

              const response = await axios.post(
                apiUrl.api_url + 'external/RSC/OwnerPartnerList/by/HubId',
                reqObj
              );

              if (response.data.code === 200 && response.data.data.length > 0) {
                this.RSCObj = response.data.data;
              } else {
                this.RSCObj = [];
                this.$alertify.error('RSC data not found.!');
              }

            } catch (err) {
              this.$alertify.error("RSC data not found");
              console.error("RSC API error:", err);
            }

            // Parent Hub API again
            try {
              const response = await axios.post(
                apiUrl.api_url + 'external/getParentHubs',
                { HubID: this.hubdetails }
              );

              if (response.data.code === 200) {
                this.parentHubObj = response.data.data;
              } else {
                this.parentHubObj = [];
                this.$alertify.error(response.data.message);
              }

            } catch (err) {
              this.$alertify.error("parent hub data not found");
              console.error("ParentHub API error:", err);
            }
          }

          if (this.isLostNewFeaturesisOnThisHub) {
            await this.LoadEmployees();
          }
        }

        // ================= BRANCH DEBIT =================
        else if (Debitfrom === "BranchDebit") {

          this.DebitModeObj = [
            { id: "Cash", Debit_mode: "Cash" },
            { id: "Cheque", Debit_mode: "Cheque" },
            { id: "Invoice", Debit_mode: "Invoice" },
            { id: "COF", Debit_mode: "COF" }
          ];

          let getHubList = localStorage.getItem('allhubaccesslist');
          var byteHub = CryptoJS.AES.decrypt(getHubList.toString(), this.userDataKey);
          var hubList = byteHub.toString(CryptoJS.enc.Utf8);
          this.hubList = JSON.parse(hubList);
        }

        await this.$nextTick();
        console.log("BindDebitFrom completed successfully.");

      } catch (error) {
        console.error("BINDPARAM CATCH EXCEPTION:", error);
      }
    },

    calculateDebitAmout(DebitAmount, percentVal = 100, userid = '') {
      if (this.selectedItems.length > 0) {
        this.isDebitPersonSelected = this.selectedItems.length;
        if (userid != '' && document.getElementById(userid).checked == false) {
          this.debitPersonAmount[userid] = '';
          this.debitPersonPercent[userid] = '';
        }
        let selectDebitUsercount = this.selectedItems.length;

        let percentage = 0;
        let amount = 0;
        if (DebitAmount == '' || DebitAmount == 0 || DebitAmount == 'undefined') {
          percentage = 0;
          amount = 0;
        } else {
          percentage = (parseFloat(percentVal) / parseFloat(selectDebitUsercount)).toFixed(2);
          amount = (parseFloat(DebitAmount) / parseFloat(selectDebitUsercount)).toFixed(2);
        }
        let adjustDebitAmount = 0;
        let raiseDebitAmount = 0;

        for (let i = 0; i < selectDebitUsercount; i++) {
          raiseDebitAmount = parseFloat(raiseDebitAmount) + parseFloat(amount);
          this.debitPersonAmount[this.selectedItems[i]] = parseFloat(amount);
          this.debitPersonPercent[this.selectedItems[i]] = parseFloat(percentage);
        }
        this.adjustDebitAmount = (parseFloat(DebitAmount) - parseFloat(raiseDebitAmount)).toFixed(2);
      } else {
        this.isDebitPersonSelected = "";
        this.debitPersonAmount[userid] = 0;
        this.debitPersonPercent[userid] = 0;
      }
      this.selectedfilteredEmpCount = this.selectedItems.length

    },
    adjustDebitPercenatge(getUserId) {
      let getdebitshareAmount = this.debitPersonAmount[getUserId];
      let getpercentage = this.debitPersonPercent[getUserId];
      let DebitAmount = this.TotalSum;
      let percentage = 0;

      if (getdebitshareAmount != '') {
        if (parseFloat(getdebitshareAmount) > parseFloat(DebitAmount)) {
          document.getElementById('debitshare' + getUserId).classList.add("validate-error");
          this.$alertify.error("Entered amount should not be greater than debit amount");
          document.getElementById('debitshare' + getUserId).focus();
          this.isAPICallFlag = false;
        } else {
          let selectedUser = this.selectedItems.length;
          for (let i = 0; i < selectedUser; i++) {
            document.getElementById('debitshare' + this.selectedItems[i]).classList.remove("validate-error");
            document.getElementById('percentage' + this.selectedItems[i]).classList.remove("validate-error");
          }
          this.isAPICallFlag = true;
        }
        percentage = ((parseFloat(getdebitshareAmount) / parseFloat(DebitAmount)) * 100).toFixed(2);
        this.debitPersonPercent[getUserId] = parseFloat(percentage);

      } else {
        this.isAPICallFlag = false;
        this.debitPersonAmount[getUserId] = 0;
        this.debitPersonPercent[getUserId] = 0;
        let filteredAry = this.selectedItems.filter(function (e) { return e !== getUserId });
        this.selectedItems = filteredAry;
        //this.$alertify.error("false");
      }
      let totaleDebitAmount = parseFloat(DebitAmount) - parseFloat(this.debitPersonAmount[getUserId]);
      let totaleDebitPercent = (parseFloat(100) - parseFloat(percentage)).toFixed(2);
      let filteredAry = this.selectedItems.filter(function (e) { return e !== getUserId });
      let getNewUpdatepercent = this.debitPersonPercent[getUserId];
      this.selectedItems = filteredAry;
      this.calculateDebitAmout(totaleDebitAmount, totaleDebitPercent);
      if (getdebitshareAmount != 0) {
        this.selectedItems.splice(0, " ", getUserId);
      }
      if (this.selectedItems.length > 0) {
        this.isDebitPersonSelected = this.selectedItems.length;
      } else {
        this.isDebitPersonSelected = "";
      }

    },

    adjustDebitAmout(getUserId) {
      let getpercentage = this.debitPersonPercent[getUserId];

      let DebitAmount = this.TotalSum;

      if (getpercentage != '') {
        if (getpercentage > 100) {
          document.getElementById('percentage' + getUserId).classList.add("validate-error");
          this.$alertify.error("Entered percent should not be greater than 100%");
          document.getElementById('percentage' + getUserId).focus();
          this.isAPICallFlag = false;
        } else {
          let selectedUser = this.selectedItems.length;
          for (let i = 0; i < selectedUser; i++) {
            document.getElementById('debitshare' + this.selectedItems[i]).classList.remove("validate-error");
            document.getElementById('percentage' + this.selectedItems[i]).classList.remove("validate-error");
          }
          this.isAPICallFlag = true;
        }
        let Amount = ((parseFloat(DebitAmount) / parseFloat(100)) * parseFloat(getpercentage)).toFixed(2);
        this.debitPersonAmount[getUserId] = parseFloat(Amount);
      } else {
        getpercentage = 0;
        this.isAPICallFlag = false;
        this.debitPersonAmount[getUserId] = 0;
        this.debitPersonPercent[getUserId] = 0;
        let filteredAry = this.selectedItems.filter(function (e) { return e !== getUserId });
        this.selectedItems = filteredAry;

      }

      let getdebitshareAmount = this.debitPersonAmount[getUserId];
      let totaleDebitAmount = parseFloat(DebitAmount) - parseFloat(getdebitshareAmount);
      let totaleDebitPercent = (parseFloat(100) - parseFloat(getpercentage)).toFixed(2);
      let filteredAry = this.selectedItems.filter(function (e) { return e !== getUserId });
      //console.log('Totaldebit',totaleDebitAmount,'totaltdebitpercent:',totaleDebitPercent);
      this.selectedItems = filteredAry;
      this.calculateDebitAmout(totaleDebitAmount, totaleDebitPercent);
      if (getpercentage != 0) {
        this.selectedItems.splice(0, " ", getUserId);
      }
      if (this.selectedItems.length > 0) {
        this.isDebitPersonSelected = this.selectedItems.length;
      } else {
        this.isDebitPersonSelected = "";
      }
    },
    calculateTotalEnteredAmt() {
      let len = this.selectedItems.length;
      let debitTotal = 0;
      // if( parseFloat(this.adjustDebitAmount) <= 0 ) {
      //   return true;
      // }
      if( len > 0) {

        for (let i = 0; i < this.selectedItems.length; i++) {
          debitTotal += Number(this.debitPersonAmount[this.selectedItems[i]] || 0);
        }

        console.log('debitTotal', debitTotal);
        console.log('debitTotal', this.TotalSum);
        console.log('this.adjustDebitAmount', this.adjustDebitAmount);
        const totalPaise = Math.round(Number(this.TotalSum) * 100);
        const debitPaise = Math.round(debitTotal * 100);
        let diffPaise = totalPaise - debitPaise; // can be -1, 0, or +1

        if (Math.abs(diffPaise) > 1) {
          this.$alertify.error("The total debit amount does not match the distributed amounts. Please adjust the split before proceeding.");
          this.isAPICallFlag = false;
          this.amountExceedError = true;
          return;
        }
        console.log("Yes Validation done.");
        console.log("this.adjustDebitAmount ===============>>>", this.adjustDebitAmount);
        if(parseFloat(this.adjustDebitAmount) > 0 ) {
          let checkReminder = this.adjustDebitAmount.split(".")
          if (checkReminder[0] != 0) {
            this.$alertify.error("Balance to be Adjust amount should be less than zero, Please adjust amount.!")
            this.isAPICallFlag = false;
            this.amountExceedError = true
            return false;
          }
        }
      }

    },


    validateForm(scope) {
      if(this.$route.query.shippingid){
        this.raiseDebitandMarkLost(scope)
      }else if (this.$route.query.id) {
        this.raiseDebitandMarkLost(scope)
      }else{
        this.$alertify.error("No data found for raise debit")
      }
    },

    raiseDebitandMarkLost(scope){
      this.search="";
      this.$validator.validateAll(scope).then(async result => {
        let tablelength = this.TableDetails.length
        let ShipmentDetails
        if (this.LostShipInfo.DebitFrom == 'ServiceCenter' && this.selectedItems.length > 0) {
          this.calculateTotalEnteredAmt();
        }
        console.log("this.isAPICallFlag =========>>>", this.isAPICallFlag);
        console.log("this.TotalSum =========>>>", this.TotalSum);
        console.log("this.result =========>>>", result);
        if (result && this.isAPICallFlag == true && this.TotalSum != 0) {
          // if (this.TableDetails[0].IsRSC == '1') {
          //   ShipmentDetails = this.rscShipmentPayload()
          // }else {
          let RaisedebitpayloadARR = []

          for(let j=0; j<tablelength; j++){

          var DebitPersonDetailsP = [];
          //var isAPICallFlag = true;
          this.isSaveLoading = true;
          let DebitID;
          if (this.LostShipInfo.DebitFrom == 'ServiceCenter' && this.selectedItems.length > 0) {
            let len = this.selectedItems.length;
            let debitTotal = 0;
            for (let i = 0; i < len; i++) {
              let debitshare = this.debitPersonAmount[this.selectedItems[i]];
              let percentage = this.debitPersonPercent[this.selectedItems[i]];
              let oldUserId = document.getElementById('olduserid' + this.selectedItems[i]).value;
              if (debitshare != '' && percentage != '') {
                debitTotal = parseFloat(debitTotal) + parseFloat(debitshare);
                let empdetailsObj = this.empDetails;
                let shippingIDConvertTosrting = (this.LostShipInfo.shippingid).toString();
                let debitFormName = empdetailsObj.find(empid => `${empid[this.keyName]}${empid[this.keyUserId]}` == this.selectedItems[i]);
                DebitPersonDetailsP.push({
                  "DeliveryUserID": debitFormName.userid,
                  "DebitFromType": this.LostShipInfo.DebitFrom,
                  "DebitPercentage": percentage,
                  "debitshare": debitshare,
                  "Comments": this.comments,
                  "olduserid": oldUserId,
                  "DebitFrom": debitFormName.username,
                  "CreatedBy": this.localusermailid,
                  "OutSourcingID": debitFormName.OutSourcingID,
                  "employeeId": debitFormName.EmployeeID
                })
              }
            }
          }

          if (this.LostShipInfo.DebitFrom == 'RSC' && this.selectedItems.length > 0) {
            let len = this.selectedItems.length;
            let debitTotal = 0;
            for (let i = 0; i < len; i++) {
              let debitshare = this.debitPersonAmount[this.selectedItems[i]];
              let percentage = this.debitPersonPercent[this.selectedItems[i]];
              // let oldUserId = document.getElementById('olduserid' + this.selectedItems[i]).value;
              DebitID =this.LostShipInfo.RSC;
              if (debitshare != '' && percentage != '') {
                debitTotal = parseFloat(debitTotal) + parseFloat(debitshare);
                let empdetailsObj = this.empDetails;
                let shippingIDConvertTosrting = (this.LostShipInfo.shippingid).toString();
                let debitFormName = empdetailsObj.find(empid => `${empid[this.keyName]}${empid[this.keyUserId]}` == this.selectedItems[i]);
                DebitPersonDetailsP.push({
                  "UserID": debitFormName.userid,
                  "DebitFromType": this.LostShipInfo.DebitFrom,
                  "DebitPercentage": percentage,
                  "debitshare": debitshare,
                  "SRName": debitFormName.username,
                  "CreatedBy": this.localusermailid,
                  "SRAgencyID": debitFormName.OutSourcingID,
                })
              }
            }
          }
          // console.log("DebitPersonDetailsP", DebitPersonDetailsP);
          DebitPersonDetailsP.length > 0 ? DebitPersonDetailsP : '';
          let olduserIds;
          let debitFromVendorName;

          if (this.LostShipInfo.DebitFrom == 'Vendor' || this.LostShipInfo.DebitFrom == 'NetworkVendor') {
            olduserIds = this.LostShipInfo.Vendor;
            debitFromVendorName = ($('#Vendor option:selected').text()).trim();
          } else if (this.LostShipInfo.DebitFrom == 'Coloader') {
            olduserIds = this.LostShipInfo.Coloader;
            debitFromVendorName = ($('#Coloader option:selected').text()).trim();
          } else if (this.LostShipInfo.DebitFrom == 'Courier') {
            olduserIds = this.oldcourieroutsourcingId[this.LostShipInfo.Courier];
            debitFromVendorName = ($('#Courier option:selected').text()).trim();
          }else if (this.LostShipInfo.DebitFrom == 'RSC') {
            olduserIds = this.LostShipInfo.RSC;
            DebitID =this.LostShipInfo.RSC;
            debitFromVendorName = ($('#RSC option:selected').text()).trim();
          }
          else if (this.LostShipInfo.DebitFrom == 'BranchDebit') {
            olduserIds = this.LostShipInfo.currentHubID;
            DebitID =this.LostShipInfo.currentHubID;
            debitFromVendorName = this.LostShipInfo.BranchDebit;
          }
          let GstAmount;
            if (this.TableDetails[j].Gst == false) {
              GstAmount = this.GstValue;
            } else {
              GstAmount = 0;
            }
            if(this.TableDetails[j].Penalty == null ||this.TableDetails[j].Penalty == undefined){
              this.TableDetails[j].Penalty = 0
            }
            let shippingIDTosrting = (this.TableDetails[j].ShippingID).toString();
            this.shippingIdForMeta = shippingIDTosrting
          let RaiseDebitPayload = {
            "ShippingID": shippingIDTosrting,
            "HubID": this.hubdetails,
            "HubName": this.TableDetails[j].CurrentHubName,
            "HubLocation": "",
            "ClientID": this.TableDetails[j].ClientID,
            "ClientName": this.TableDetails[j].ClientName,
            "HubZoneID": this.TableDetails[j].CurrentHubZoneID,
            "HubZoneName": this.TableDetails[j].CurrentHubZoneName,
            "DebitFromType": this.LostShipInfo.DebitFrom,
            "DebitMode": this.LostShipInfo.DebitMode,
            "NetPayment": this.TableDetails[j].NetPayment,
            "NetShipmentValue": this.TableDetails[j].GreaterDebitAMt,
            "DebitAmount": this.TableDetails[j].GreaterDebitAMt,
            "OctroiMRP": this.TableDetails[j].OctroiMRP,
            "PenaltyAmount":this.TableDetails[j].Penalty,
            "IsGST": this.TableDetails[j].Gst,
            "GSTAmount": GstAmount,
            "TotalDebitAmount": this.TableDetails[j].TotalDebitAmt,
            "Comments": this.comments,
            "DocketNumber": this.DocketNumber,
            "CreatedBy": this.localusermailid,
            "DebitPersonDetails": DebitPersonDetailsP,
            "adjustDebitAmount": this.adjustDebitAmount,
            "ColoaderID": this.LostShipInfo.Coloader != "" ? this.LostShipInfo.Coloader : undefined,
            "VehicleVendorID": this.LostShipInfo.Vendor != "" ? this.LostShipInfo.Vendor : undefined,
            "CourierID": this.LostShipInfo.Courier != "" ? this.LostShipInfo.Courier : undefined,
            "Attachment": this.attachmentPath,
            "BankChalanNo": this.ChallanNumber,
            "olduserid": olduserIds,
            "DebitID":DebitID,
            "DebitFrom": debitFromVendorName,
            "ShipmentType" :this.TableDetails[j].ShipmentType,
            "Vertical" : this.TableDetails[j].Vertical,
            "CenterType": this.TableDetails[j].CenterType,
            "AOR": this.TableDetails[j].AOR,
            "jobProfile": this.userInfo.jobProfile
          }
          if (this.$route.query.reason){
            RaiseDebitPayload.LostReason = this.$route.query.reason[0]
            RaiseDebitPayload.SubLostReason = this.$route.query.reason[1]
          }
          RaisedebitpayloadARR.push(RaiseDebitPayload);
        }
        ShipmentDetails = {RaisedebitpayloadARR}
        console.log("-=-=-=-=-==========================", ShipmentDetails)

        /**
          @potential Lost debits.
        */
        if (this.TableDetails[0].ispotentiallost && this.currentDebitDetails.potentialLostNoDebit) {
          // Insert New Debits.
          await this.InsertNewDebitForPotentialLost(ShipmentDetails);
          this.isSaveLoading = false;
          return true;
        }
        /**
          @debit comparison does this
        */

        let getCompResult =  await this.VerifyDebitsExistingVsOld(ShipmentDetails, this.currentDebitDetails);
        if( getCompResult.unmatched.length == 0 ) {
          // console.log("this.currentDebitDetails ==========================>>>>>>>", this.currentDebitDetails);
          let rmapprovalStatus = [{
            "ShipmentLostMasterID": this.currentDebitDetails.shipmentlostdebitdetails[0].ShipmentLostMasterID,
            "DebitPersonDetails": [{
              "ShipmentLostDetailsID": this.currentDebitDetails.shipmentlostdebitdetails[0].ShipmentLostDetailsID,
              "DebitAmount": this.currentDebitDetails.shipmentlostdebitdetails[0].DebitAmount
            }],
            "Comments" : "Success",
            "LastModifiedBy": this.localusermailid,
            "roles": this.userRoleList
          }]
          this.rmApproved(rmapprovalStatus);
          return true;
        }
        console.log("getCompResult =================>>>", getCompResult);
      // }
      let OldPayloadRequest = {};
      OldPayloadRequest.DebitFromType = this.currentDebitDetails.DebitFromType
      OldPayloadRequest.shipmentlostdebitdetails = this.currentDebitDetails.shipmentlostdebitdetails
      OldPayloadRequest.DebitPersonalDetails = this.currentDebitDetails.DebitPersonalDetails
      OldPayloadRequest.compareResult = getCompResult
      OldPayloadRequest.updateAction = 'rmuser'

      ShipmentDetails.updateDetails = OldPayloadRequest;
      // ShipmentDetails.compareResult = getCompResult;

      let route = ''
        if(this.$route.query.shippingid){
          route = 'shipmentLost/pushRaiseDebitDataInSQS';
        }else if (this.$route.query.id) {
          route = 'shipmentLost/updateRaiseDebit';
        }
          axios.post(apiUrl.api_url + route, ShipmentDetails)
            .then((response) => {
              if (response.data.code == 200 && this.$route.query.shippingid){
                this.$alertify.success(response.data.message);
                this.$router.push('/RMApprove');
              }else if ((response.data.code == 202 || response.data.code == 204) && this.$route.query.shippingid){
                this.$alertify.error(response.data.message);
                this.$router.push('/RMApprove');
              }else if (response.data.code === 200 && this.$route.query.id) {
                //tracker api called here
                let TrackerInfo = {
                  projectname: "Last Mile",
                  type: "Web",
                  userid: this.localuserid,
                  username: this.localusermailid,
                  meta: {
                    "event": "saveHubMarkLostDebit",
                    "shippingId": this.shippingIdForMeta,
                    "DebitMode": this.LostShipInfo.DebitMode,
                    "NetPayment": this.LostShipInfo.netAmt,
                    "Comments": this.comments,
                    "DocketNumber": this.DocketNumber,
                    "ColoaderID": this.LostShipInfo.Coloader != "" ? this.LostShipInfo.Coloader : undefined,
                    "VehicleVendorID": this.LostShipInfo.Vendor != "" ? this.LostShipInfo.Vendor : undefined,
                    "CourierID": this.LostShipInfo.Courier != "" ? this.LostShipInfo.Courier : undefined,
                    "BankChalanNo": this.ChallanNumber
                  }
                }
                this.PageTracker(TrackerInfo);
                //end
              this.apiResponseforTable = response.data.data
              let Reslength = this.apiResponseforTable.length
              for(let i=0; i<Reslength; i++){
                if (Object.keys(this.apiResponseforTable[i]).length!=0){
                    this.apiResponseforTable[i].ShippindIds = response.data.data[i].ShippindIds.toString()
                }
              }
              if (this.apiResponseforTable.find(o => o.code !== 200) ) {
                this.modelValue = true;
              } else {
                this.$alertify.success(this.apiResponseforTable[0].message);
                this.$router.push('/RMApprove');
              }
              } else {
                this.$alertify.error(response.data.message);
              }
              this.isSaveLoading = false
            })
            .catch((httpException) => {
              this.isSaveLoading = false
              this.$alertify.error("Unable to update raise debit");
              console.error('exception is:::::::::', httpException)
            })
          //Raise Debit API Integration end
        } else {
          if (this.TotalSum == 0) {
            this.$alertify.error("Net payment or octroi amount must be greater than Zero");
          } else {
            this.$alertify.error("Please check Validation failed .!");
          }
        }
      });
    },
    rmApproved(payload){
        axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/approveDebit',payload)
        .then((response) => {

          if(response.data.code == 200){
            this.$alertify.success(response.data.message);
            this.$router.push('/RMApprove');
          } else if(response.data.code == 202) {
            this.$alertify.error(response.data.message);
          } else {
            this.$alertify.error("Internal server Error");
          }
          this.isSaveLoading = false
          //  this.RMApproveAllRecord=false;
          // this.RmApproveLoaderBtn = false
          // this.totalSelectedRecords = 0
      })
      .catch((httpException) => {
        // this.RMApproveAllRecord=false;
        // this.RmApproveLoaderBtn = false
        // this.totalSelectedRecords = 0
        // this.totalDebitAmount=0;
        // this.addDebitAmt=0;
        this.isSaveLoading = false
        console.error('exception is:::::::::',httpException)
      });
    },
    InsertNewDebitForPotentialLost(req) {
      return new Promise((resolve, reject) => {
        try{

            req.RaisedebitpayloadARR[0].LostReason = 'Lost_By_Staff'
            req.RaisedebitpayloadARR[0].SubLostReason = 'Untraceble In Branch'

            axios.post(apiUrl.api_url + 'shipmentLost/RMApproveAndRaiseDebit/InsertDebits',req)
            .then((response) => {
              // console.log("response ============>>", response.data);
              let debitAPIResult = response.data.data.details[0];
              console.log("debitAPIResult =========>>", debitAPIResult.code);
              if(debitAPIResult.code == 200){
                this.$alertify.success(debitAPIResult.message);
                this.$router.push('/RMApprove');
              } else {
                this.$alertify.error(debitAPIResult.message);
                this.$router.push('/RMApprove');
              }
              return resolve(true);
            }) .catch((httpException) => {
              console.error('exception is:::::::::',httpException)
              return resolve(false);
          });
        } catch(e) {
          console.log("InsertNewDebitForPotentialLost =====>>>>", e);
        }
      })
    },
    rscShipmentPayload() {
      let tablelength = this.TableDetails.length
        let RaisedebitpayloadARR = []
        for (let j = 0; j < tablelength; j++) {
          let DebitPersonDetailsP = [];
          this.isSaveLoading = true;
              let debitshare = parseFloat(this.TableDetails[j].OctroiMRP) > parseFloat(this.TableDetails[j].NetPayment) ? parseFloat(this.TableDetails[j].OctroiMRP) : parseFloat(this.TableDetails[j].NetPayment);
              let percentage = 100;
              if (debitshare != '' && percentage != '') {
                let shippingIDConvertTosrting = (this.TableDetails[j].ShippingID).toString();
                let debitFormName = this.TableDetails[j].NotifyNoInfoDetail
                DebitPersonDetailsP.push({
                  "DeliveryUserID": debitFormName.RSCMasterId,
                  "DebitFromType": 'ServiceCenter',
                  "DebitPercentage": percentage,
                  "Comments": this.comments,
                  "olduserid": "",
                  "DebitFrom": debitFormName.rscownername,
                  "CreatedBy": this.localusermailid,
                  "OutSourcingID": debitFormName.OutSourcingID
                })
              }
          DebitPersonDetailsP.length > 0 ? DebitPersonDetailsP : '';
          let GstAmount;
            if (this.TableDetails[j].Gst == false) {
              GstAmount = this.GstValue;
            } else {
              GstAmount = 0;
            }
            if(this.TableDetails[j].Penalty == null ||this.TableDetails[j].Penalty == undefined){
              this.TableDetails[j].Penalty = 0
            }
          let shippingIDTosrting = (this.TableDetails[j].ShippingID).toString();
          this.shippingIdForMeta = shippingIDTosrting
          let olduserIds;
          let debitFromVendorName;
          let RaiseDebitPayload = {
            "ShippingID": shippingIDTosrting,
            "HubID": this.hubdetails,
            "HubName": this.TableDetails[j].CurrentHubName,
            "HubLocation": "",
            "ClientID": this.TableDetails[j].ClientID,
            "ClientName": this.TableDetails[j].ClientName,
            "HubZoneID": this.TableDetails[j].CurrentHubZoneID,
            "HubZoneName": this.TableDetails[j].CurrentHubZoneName,
            "DebitFromType": 'ServiceCenter',
            "DebitMode": this.LostShipInfo.DebitMode,
            "NetPayment": this.TableDetails[j].NetPayment,
            "NetShipmentValue": this.TableDetails[j].GreaterDebitAMt,
            "DebitAmount": this.TableDetails[j].GreaterDebitAMt,
            "OctroiMRP": this.TableDetails[j].OctroiMRP,
            "PenaltyAmount":this.TableDetails[j].Penalty,
            "IsGST": this.TableDetails[j].Gst,
            "GSTAmount": GstAmount,
            "TotalDebitAmount": this.TableDetails[j].TotalDebitAmt,
            "Comments": this.comments,
            "DocketNumber": this.DocketNumber,
            "CreatedBy": this.localusermailid,
            "DebitPersonDetails": DebitPersonDetailsP,
            "adjustDebitAmount": this.adjustDebitAmount,
            "ColoaderID": this.LostShipInfo.Coloader != "" ? this.LostShipInfo.Coloader : undefined,
            "VehicleVendorID": this.LostShipInfo.Vendor != "" ? this.LostShipInfo.Vendor : undefined,
            "CourierID": this.LostShipInfo.Courier != "" ? this.LostShipInfo.Courier : undefined,
            "Attachment": this.attachmentPath,
            "BankChalanNo": this.ChallanNumber,
            "olduserid": "",
            "DebitFrom": debitFromVendorName,
            "LostReason": this.$route.query.reason[0],
            "SubLostReason": this.$route.query.reason[1],
            "CenterType": this.TableDetails[j].CenterType,
            "Vertical" : this.TableDetails[j].Vertical,
            "ShipmentType" :this.TableDetails[j].ShipmentType,
            "AOR":  this.TableDetails[j].AOR
          }
          RaisedebitpayloadARR.push(RaiseDebitPayload);
        }
        let rscPayload = { RaisedebitpayloadARR }
        return rscPayload
    },
    closeApprovalResultModel() {
      this.modelValue = false
      this.$router.push('/MarkLostShipment');
    },
    async LoadEmployees(isReset) {
      try {
        if (isReset) {
          this.empDetails = [];
          return;
        }

        // Hub selection logic
        if (this.selectedRSCHubs.length === 0) {
          this.selectedRSCHubs.push(this.hubdetails);
        }

        this.selectedItems = [];
        this.debitPersonAmount = [];
        this.debitPersonPercent = [];

        let Emppayload = {
          appkey: '$LAST$Mile%#$',
          HubId: this.selectedRSCHubs
        };

        // ✅ New feature hub logic
        if (this.isLostNewFeaturesisOnThisHub) {
          Emppayload.LoggedInUserJobProfile = this.LoggedInUserJobProfile;

          const dateStr = this.TableDetails[0].CreatedDate;
          const date = new Date(dateStr);
          const formatted = date.toISOString().split('T')[0];
          Emppayload.Date = formatted;

        }
        // ✅ Old logic
        else {
          let adminobject = this.users.filter(
            (obj) => obj.EmpTypeName.trim().toLowerCase() === 'hub_executive'
          );

          if (this.selectAlluser) {
            if (
              adminobject.length > 0 &&
              this.debitCatSelected.includes(adminobject[0].EmpTypeId)
            ) {
              if (this.debitCatSelected.length === 1) {
                this.utype = [2];
                this.debitCatSelected = [];
              } else {
                let idx = this.debitCatSelected.indexOf(adminobject[0].EmpTypeId);
                this.debitCatSelected.splice(idx, 1);
                this.utype = [2, 3];
              }
            } else {
              this.utype = [3];
            }
          }
          else if (
            adminobject.length > 0 &&
            this.debitCatSelected.includes(adminobject[0].EmpTypeId)
          ) {
            if (this.debitCatSelected.length === 1) {
              this.utype = [2];
              this.debitCatSelected = [];
            } else {
              let idx = this.debitCatSelected.indexOf(adminobject[0].EmpTypeId);
              this.debitCatSelected.splice(idx, 1);
              this.utype = [2, 3];
            }
          }
          else {
            this.utype = [3];
          }

          Emppayload.EmpType = this.debitCatSelected;
          Emppayload.utype = this.utype;
        }

        console.log("Emppayload", Emppayload);

        this.isDebitPersonLoading = true;

        let apiendpoint = 'external/getHubEmpDetails';

        if (keycloak.enableKavach && !this.isLostNewFeaturesisOnThisHub) {
          apiendpoint = 'user/migration/gethubempdetails';
        }

        if (keycloak.enableKavach && this.isLostNewFeaturesisOnThisHub) {
          apiendpoint = 'user/v2/migration/gethubempdetailsv2';
        }

        // ✅ API Call using await
        const response = await axios.post(apiUrl.api_url + apiendpoint, { Emppayload });

        if (response.data.code === 200) {
          this.empDetails = response.data.data;
        } else {
          this.empDetails = [];
          this.$alertify.error("Record Not found");
        }

      } catch (error) {
        this.$alertify.error("Employee data not found");
        console.error("exception is:::::::::", error);
      } finally {
        this.isDebitPersonLoading = false;
      }
    },

    // LoadEmployees(isReset) {
    //   if (isReset) {
    //     this.empDetails = []
    //   } else {
    //     if (this.selectedRSCHubs.length === 0) {
    //       this.selectedRSCHubs.push(this.hubdetails);
    //     }
    //     this.selectedItems = [];
    //     this.debitPersonAmount = [];
    //     this.debitPersonPercent = [];
    //     //load all employess list with emptype and without emp type when select cat ALL / ROLLBACKED THIS CHANGE FROM LIVE.
    //     let Emppayload = {
    //       "appkey": '$LAST$Mile%#$',
    //       "HubId": this.selectedRSCHubs
    //     }
    //     if(this.isLostNewFeaturesisOnThisHub) {
    //       Emppayload.LoggedInUserJobProfile =  this.LoggedInUserJobProfile
    //
    //       const dateStr = this.TableDetails[0].CreatedDate;
    //       const date = new Date(dateStr);
    //       const formatted = date.toISOString().split('T')[0];
    //       Emppayload.Date = formatted
    //
    //     } else {
    //       let adminobject = this.users.filter((obj) => obj.EmpTypeName.trim().toLowerCase() == 'hub_executive');
    //       // console.log('Admin Object --------->>', adminobject);
    //         if(this.selectAlluser){
    //           console.log("this.debitSelected", this.debitCatSelected);
    //           if(adminobject.length>0 && this.debitCatSelected.includes(adminobject[0].EmpTypeId)){
    //             if(this.debitCatSelected.length == 1) {
    //               this.utype = [2]
    //               this.debitCatSelected = []
    //             }else{
    //               let getidxref = this.debitCatSelected.indexOf(adminobject[0].EmpTypeId);
    //                 this.debitCatSelected.splice(getidxref, 1);
    //                 this.utype = [2,3]
    //             }
    //           }else{
    //             this.utype=[3]
    //           }
    //         }else if(adminobject.length > 0 && this.debitCatSelected.includes(adminobject[0].EmpTypeId)){
    //           if(this.debitCatSelected.length == 1) {
    //             this.utype = [2]
    //             this.debitCatSelected = []
    //           }else{
    //             let getidxref = this.debitCatSelected.indexOf(adminobject[0].EmpTypeId);
    //               this.debitCatSelected.splice(getidxref, 1);
    //               this.utype = [2,3]
    //           }
    //         }else{
    //             this.utype=[3]
    //           }
    //
    //       // let Emppayload = {
    //       //   "appkey": '$LAST$Mile%#$',
    //       //   "HubId": this.selectedRSCHubs,
    //       //   "EmpType": this.debitCatSelected,
    //       //   "utype":  this.utype
    //       //   // "EmpType" : this.userIds
    //       // }
    //       Emppayload.EmpType =  this.debitCatSelected
    //       Emppayload.utype =  this.utype
    //     }
    //     console.log('Emppayload',Emppayload);
    //     this.isDebitPersonLoading = true;
    //     let apiendpoint = 'external/getHubEmpDetails';
    //     if (keycloak.enableKavach && !this.isLostNewFeaturesisOnThisHub) {
    //       apiendpoint = 'user/migration/gethubempdetails';
    //     }
    //     if (keycloak.enableKavach && this.isLostNewFeaturesisOnThisHub) {
    //       apiendpoint = 'user/v2/migration/gethubempdetailsv2';
    //     }
    //     axios.post(apiUrl.api_url + apiendpoint, { Emppayload })
    //       .then((response) => {
    //         if (response.data.code === 200) {
    //           //console.log('emp.getHubEmpDetails',response.data.data);
    //           this.empDetails = response.data.data;
    //         }
    //         else {
    //           this.empDetails = [];
    //           this.$alertify.error("Record Not found");
    //         }
    //         this.isDebitPersonLoading = false;
    //       })
    //       .catch((httpException) => {
    //         this.$alertify.error("Employee data not found");
    //         console.error('exception is:::::::::', httpException)
    //         this.isDebitPersonLoading = false;
    //       })
    //   }
    // },
    onUpload(event) {
      this.getUploadError = [];
      const file = event.target.files[0];
      this.file = file;
      this.Loading = true;
      this.validated = false;

      //image upload code start here
      const formData = new FormData();
      formData.append('ShippingID', this.LostShipInfo.shippingid);
      formData.append('file', this.file);
      if (this.file.size <= 1024 * 1024 * 5) {

        axios.post(apiUrl.api_url + 'raiseDebit/LostFileUploads', formData)
          .then((response) => {
            if (response.data.code === 200) {
              this.getUploadError = [{ 'title': 'success', 'detail': 'file Uploaded successfully !!' }];
              this.attachmentPath = response.data.imageUrl;
              this.uploadError = this.getUploadError.length;
              console.log('this.attachmentPath', this.attachmentPath);
              this.validated = true;
            } else {
              this.uploadError = '';
              this.attachmentPath = '';
              this.getUploadError = response.data.errors;
              //console.log('this.getUploadError',this.getUploadError);
              // const input = this.$refs.FileUploadAcceptanceLetter;
              // input.type = 'text';
              // input.type = 'file';
              this.validated = false;
            }
            this.Loading = false;
          })
          .catch((httpException) => {
            console.error('exception is :::::::::', httpException)
            this.Loading = false;
            this.validated = true;
            this.isAPICallFlag = false;
          })
      } else {
        this.$alertify.error("Please check image size should be less than 5MB ");
        // const input = this.$refs.FileUploadAcceptanceLetter;
        // input.type = 'text';
        // input.type = 'file';
        this.validated = true;
        this.Loading = false;
      }
      //image upload code end here

    },
    resetTypeFilter() {
      this.userIds = [];
      this.DebitUserSelectedOptions = []
      this.debitCatSelected = []
      //document.getElementById('selectAlluser').checked = false;
      this.selectedItems = [];
      this.debitPersonAmount = [];
      this.debitPersonPercent = [];
      this.LoadEmployees(true);
    },
    onlyNumber: function ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 8) {
        $event.preventDefault();
      }
    },
    reset() {
      this.empDetails = []
      this.DebitUserSelectedOptions = []
      this.LostShipInfo.DebitFrom = '';
      this.selectedItems = [];
      this.selectAllItems = false;
      $("input:text").val('');
      this.clear();
      this.validated = true;
      this.TotalSum = 0;
      let resLen = this.TableDetails.length
            for(let i=0;i<resLen;i++){
              this.TableDetails[i].GstAmount = 0;
              this.TableDetails[i].Gst = true;
              this.TableDetails[i].Penalty = 0;
              this.TableDetails[i].TotalDebitAmt = this.TableDetails[i].GreaterDebitAMt;
              $(`#index_${i}`).html(this.TableDetails[i].GreaterDebitAMt)
              this.TotalSum = parseFloat(this.TotalSum) + parseFloat(this.TableDetails[i].GreaterDebitAMt);
             }
    },
    clear() {
      //this.LostShipInfo = '';

      this.LostShipInfo.DebitMode = '';
      this.LostShipInfo.Coloader = '';
      this.LostShipInfo.Courier = '';
      this.LostShipInfo.Vendor = '';
      // this.LostShipInfo.facility = '';
      this.DocketNumber = '';
      this.comments = '';
      this.attachmentPath = '';
      this.ChallanNumber = '';
      this.search = '';
      this.userIds = [];
      //document.getElementById('selectAlluser').checked = false;
      // const input = this.$refs.FileUploadAcceptanceLetter;
      // input.type = 'text';
      // input.type = 'file';
      this.uploadError = '';
      this.getUploadError = '';
      this.validated = true;
      this.$validator.reset();
      this.errors.clear();
    },
    toggleSortByType() {
      this.sortByTypeAsc = !this.sortByTypeAsc;
      // Move 'Type' to the end to make it the most recent sort
      this.sortPriority = this.sortPriority.filter(k => k !== 'Type');
      this.sortPriority.push('Type');
    },
    toggleSortByVertical() {
      this.sortByVerticalAsc = !this.sortByVerticalAsc;
      this.sortPriority = this.sortPriority.filter(k => k !== 'Vertical');
      this.sortPriority.push('Vertical');
    },
    async VerifyDebitsExistingVsOld(currentPayload, PreviousPayload){
      try {
        const getDebitFromResult = {
          matched: [],
          unmatched: []
        };
        const isDebitFromTypeChanged = currentPayload.RaisedebitpayloadARR[0].DebitFromType != PreviousPayload.DebitFromType;
        if ( isDebitFromTypeChanged ) {

          getDebitFromResult.unmatched.push({
            changeType: 'DEBIT_FROM_TYPE_CHANGED',
            headerChange: {
              old: PreviousPayload.DebitFromType,
              new: currentPayload.RaisedebitpayloadARR[0].DebitFromType
            },
            skipNestedCompare: true
          });
          return getDebitFromResult;
        }

        if ( parseFloat(currentPayload.RaisedebitpayloadARR[0].PenaltyAmount) != parseFloat(PreviousPayload.CurrentPenalty)) {

          getDebitFromResult.unmatched.push({
            changeType: 'DEBIT_PENALTY_AMOUNT_CHANGED',
            headerChange: {
              old: PreviousPayload.CurrentPenalty,
              new: currentPayload.RaisedebitpayloadARR[0].PenaltyAmount
            },
            skipNestedCompare: true
          });
          return getDebitFromResult;
        }

        console.log("currentPayload =====================>> ", currentPayload);
        console.log("PreviousPayload =====================>> ", PreviousPayload);

        const comparisonResult = await this.compareDebitDetails(currentPayload, PreviousPayload);
        console.log(" comparisonResult RESULT ===>>>", comparisonResult);
        return comparisonResult;
      } catch(e) {
        console.log("Comparison request failed.",e);
      }
    },
    async compareDebitDetails(currentArrDebit, previousArrPayload) {

      const result = {
        matched: [],
        unmatched: []
      };
      let debittype = currentArrDebit.RaisedebitpayloadARR[0].DebitFromType
      if(debittype == 'ServiceCenter') {
        let currentArr = currentArrDebit.RaisedebitpayloadARR[0].DebitPersonDetails
        let previousArr = previousArrPayload.mergeDebitPersonsToCompareEdits
          // Map previous by employeeId
          const prevMap = new Map();
          previousArr.forEach(p => {
            prevMap.set(String(p.employeeId), p);
          });

          // Check current → previous
          currentArr.forEach(curr => {
            const empId = String(curr.employeeId);
            const prev = prevMap.get(empId);

            // Case 1: New employee
            if (!prev) {
              result.unmatched.push({
                employeeId: empId,
                reason: 'NEW_EMPLOYEE_ADDED',
                current: curr
              });
              return;
            }

            const prevAmount = Number(prev.DebitAmount);
            const currAmount = Number(curr.debitshare);

            // Case 2: Same employee, amount mismatch
            if (!Number.isNaN(prevAmount) && !Number.isNaN(currAmount)) {
              if (prevAmount !== currAmount) {
                result.unmatched.push({
                  employeeId: empId,
                  reason: 'DEBIT_AMOUNT_CHANGED',
                  previousAmount: prevAmount,
                  currentAmount: currAmount
                });
                return;
              }
            }

            // Case 3: Fully matched
            result.matched.push({
              employeeId: empId,
              debitAmount: currAmount,
              status: 'MATCH'
            });
          });

          // Case 4: Employee removed
          previousArr.forEach(prev => {
            const exists = currentArr.some(
              c => String(c.employeeId) === String(prev.employeeId)
            );

            if (!exists) {
              result.unmatched.push({
                employeeId: String(prev.employeeId),
                reason: 'EMPLOYEE_REMOVED',
                previous: prev
              });
            }
          });

          console.log("RESULT ======>>", result);
          return result;

        } else if(debittype == 'Courier') {
          let comparecurrentObj = currentArrDebit.RaisedebitpayloadARR[0];
          let compareOldObj = previousArrPayload.shipmentlostdebitdetails[0];
          if(comparecurrentObj.CourierID != compareOldObj.CourierID) {
            result.unmatched.push({
              employeeId: compareOldObj.CourierID,
              reason: 'COURIER_CHANGED',
              previousAmount: compareOldObj.CourierID,
              currentAmount: comparecurrentObj.CourierID
            });
          } else {
            result.matched.push({
              employeeId: compareOldObj.CourierID,
              debitAmount: compareOldObj.CourierID,
              status: 'MATCH'
            });
          }
          return result;
        } else if (debittype == 'RSC' || debittype == 'Store' || debittype == 'BranchDebit') {
          let comparecurrentObj = currentArrDebit.RaisedebitpayloadARR[0];
          let compareOldObj = previousArrPayload.shipmentlostdebitdetails[0];
          if(comparecurrentObj.DebitID != compareOldObj.DebitID) {
            result.unmatched.push({
              employeeId: compareOldObj.DebitID,
              reason: `${debittype}_CHANGED`,
              previousAmount: compareOldObj.DebitID,
              currentAmount: comparecurrentObj.DebitID
            });
          } else {
            result.matched.push({
              employeeId: compareOldObj.DebitID,
              debitAmount: compareOldObj.DebitID,
              status: 'MATCH'
            });
          }
          return result;
        }
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/components/LOST/EditDebit/EditDebit.component.js